import { request } from '@/fetch/core';
import { Method } from '@/fetch/core/util';
import { RoadTestPaths } from './paths';
import {
  ApiResponse,
  CreateRoadTestTaskParams,
  GetRoadTestSchemeListParams,
  GetRoadTestTaskDetailParams,
  GetVehicleReplaySegmentsParams,
  SaveRoadTestTaskParams,
  CancelRoadTestTaskParams,
  RoadTestScheme,
  RoadTestTaskDetail,
  VehicleReplaySegment,
} from './types';

class RoadTestApi {
  /**
   * 根据车号及路测类型获取路测方案列表
   */
  async getSchemeList(
    params: GetRoadTestSchemeListParams
  ): Promise<ApiResponse<{ schemeList: RoadTestScheme[] }>> {
    const requestParam: RequestOptions = {
      method: Method.POST,
      path: RoadTestPaths.GET_ROAD_TEST_SCHEME_LIST.fullPath,
      body: params,
    };
    return request(requestParam) as Promise<
      ApiResponse<{ schemeList: RoadTestScheme[] }>
    >;
  }

  /**
   * 获取路测任务详情（轮询）
   */
  async getRoadTaskDetail(
    params: GetRoadTestTaskDetailParams
  ): Promise<ApiResponse<RoadTestTaskDetail>> {
    const requestParam: RequestOptions = {
      method: Method.POST,
      path: RoadTestPaths.GET_ROAD_TEST_TASK_DETAIL.fullPath,
      body: params,
    };
    return request(requestParam) as Promise<ApiResponse<RoadTestTaskDetail>>;
  }

  /**
   * 创建路测任务
   */
  async createTask(
    params: CreateRoadTestTaskParams
  ): Promise<ApiResponse<{ taskNo: string }>> {
    const requestParam: RequestOptions = {
      method: Method.POST,
      path: RoadTestPaths.CREATE_ROAD_TEST_TASK.fullPath,
      body: params,
    };
    return request(requestParam) as Promise<ApiResponse<{ taskNo: string }>>;
  }

  /**
   * 保存路测任务详情
   */
  async saveTaskDetail(
    params: SaveRoadTestTaskParams
  ): Promise<ApiResponse<void>> {
    const requestParam: RequestOptions = {
      method: Method.POST,
      path: RoadTestPaths.SAVE_ROAD_TEST_TASK_DETAIL.fullPath,
      body: params,
    };
    return request(requestParam) as Promise<ApiResponse<void>>;
  }

  /**
   * 提交路测任务详情
   */
  async submitTaskDetail(
    params: SaveRoadTestTaskParams
  ): Promise<ApiResponse<void>> {
    const requestParam: RequestOptions = {
      method: Method.POST,
      path: RoadTestPaths.SUBMIT_ROAD_TEST_TASK_DETAIL.fullPath,
      body: params,
    };
    return request(requestParam) as Promise<ApiResponse<void>>;
  }

  /**
   * 作废路测任务
   */
  async cancelTask(
    params: CancelRoadTestTaskParams
  ): Promise<ApiResponse<void>> {
    const requestParam: RequestOptions = {
      method: Method.POST,
      path: RoadTestPaths.CANCEL_ROAD_TEST_TASK.fullPath,
      body: params,
    };
    return request(requestParam) as Promise<ApiResponse<void>>;
  }

  /**
   * 获取整车回放分段列表
   */
  async getVehicleReplaySegments(
    params: GetVehicleReplaySegmentsParams
  ): Promise<ApiResponse<VehicleReplaySegment[]>> {
    const requestParam: RequestOptions = {
      method: Method.POST,
      path: RoadTestPaths.GET_VEHICLE_REPLAY.fullPath,
      body: params,
    };
    return request(requestParam) as Promise<
      ApiResponse<VehicleReplaySegment[]>
    >;
  }
}

export default RoadTestApi;
export const roadTestApi = new RoadTestApi();
export type { RoadTestScheme };
